const formatShortDate = (dateStr) => {
    if (dateStr == null) {
        return "";
    }
    const date = new Date(String(dateStr));
    if (Number.isNaN(date.getTime())) {
        return String(dateStr);
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}.${month}.${year}`;
};
const getStringFromNrOfCharsInFormula = (nrOfChars, value) => {
    const minLength = nrOfChars ?? 3;
    const valueAsString = value.toString();
    if (valueAsString.length >= minLength) {
        return valueAsString;
    }
    return "0".repeat(minLength - valueAsString.length) + valueAsString;
};
const mergeIssueCounts = (data) => {
    return data.reduce((acc, entry) => {
        Object.entries(entry.issueCounts).forEach(([key, value]) => {
            acc[key] = value;
        });
        return acc;
    }, {});
};
const getOtherAttributesConfigRecord = (otherAttributesConfig) => {
    if (otherAttributesConfig == null) {
        return {};
    }
    if (otherAttributesConfig instanceof Map) {
        return Object.fromEntries(otherAttributesConfig);
    }
    return otherAttributesConfig;
};
export const formatIssueFormulaGeneratedString = (args) => {
    const config = getOtherAttributesConfigRecord(args.otherAttributesConfig);
    return args.formula.confArr.reduce((acc, conf) => {
        if (conf.type === "DELIMITER") {
            acc += conf.value;
        }
        if (conf.type === "ATTRIBUTE") {
            const issueRecord = args.issue;
            const value = args.issue.otherAttributesData?.[conf.value] ?? issueRecord[conf.value];
            if (value != null && value !== "") {
                acc += config[conf.value]?.typeOfValue === "DATE" ? formatShortDate(value) : String(value);
            }
            else if (args.deletePreviousDelimiterIfAttributeIsEmpty) {
                const previousConf = args.formula.confArr[args.formula.confArr.indexOf(conf) - 1];
                if (acc.length > 0 && previousConf?.type === "DELIMITER") {
                    acc = acc.slice(0, -previousConf.value.length);
                }
            }
        }
        if (conf.type === "COUNTER") {
            if (args.countForIssue == null) {
                const previousConf = args.formula.confArr[args.formula.confArr.indexOf(conf) - 1];
                if (acc.length > 0 && previousConf?.type === "DELIMITER") {
                    acc = acc.slice(0, -previousConf.value.length);
                }
                return acc;
            }
            acc += getStringFromNrOfCharsInFormula(args.formula.nrOfCharsInCounter, args.countForIssue);
        }
        return acc;
    }, "");
};
export const getGeneratedStringForFormulaOnAllKeys = (args) => {
    const generatedStrings = {};
    const otherAttributesConfig = getOtherAttributesConfigRecord(args.issueBoard?.otherAttributesConfig);
    if (args.issues == null) {
        return generatedStrings;
    }
    const formulaAttributes = Object.entries(otherAttributesConfig).filter(([, attribute]) => attribute.typeOfValue === "FORMULA" && attribute.formula != null);
    const issueCountsByFormulaKey = formulaAttributes.reduce((acc, [key, attribute]) => {
        if (attribute.formula?.counterMode !== "MANUAL") {
            acc[key] = mergeIssueCounts(args.countersForIssuesOnAllKeys?.[key] || []);
        }
        return acc;
    }, {});
    args.issues.forEach((issue) => {
        if (issue == null)
            return;
        if (issue.taskOrIssue === "TASK")
            return;
        const issueId = issue.id;
        if (issueId == null)
            return;
        const otherAttributesData = issue.otherAttributesData;
        formulaAttributes.forEach(([key, attribute]) => {
            const formula = attribute.formula;
            if (formula == null)
                return;
            const manualCounterValue = formula.counterMode === "MANUAL" ? issue.formulaCounters?.[key]?.value : null;
            const generatedString = formatIssueFormulaGeneratedString({
                formula,
                countForIssue: formula.counterMode === "MANUAL" ? manualCounterValue ?? null : issueCountsByFormulaKey[key]?.[issueId] ?? 0,
                deletePreviousDelimiterIfAttributeIsEmpty: formula.deletePreviousDelimiterIfAttributeIsEmpty ?? false,
                issue: { ...issue, otherAttributesData },
                otherAttributesConfig,
            });
            generatedStrings[issueId] = generatedStrings[issueId] || {};
            generatedStrings[issueId][key] = generatedString;
        });
    });
    return generatedStrings;
};
export const issueBoardContainsFormula = (issueBoard) => {
    return Object.values(getOtherAttributesConfigRecord(issueBoard?.otherAttributesConfig)).some((attribute) => attribute.typeOfValue === "FORMULA");
};
export const issueBoardContainsAutomaticFormula = (issueBoard) => {
    return Object.values(getOtherAttributesConfigRecord(issueBoard?.otherAttributesConfig)).some((attribute) => attribute.typeOfValue === "FORMULA" &&
        attribute.isActive === true &&
        attribute.formula?.counterMode !== "MANUAL");
};
export const getIssuesWithFormulaAdded = (args) => {
    if (args.issues == null || args.issueBoard == null) {
        return args.issues;
    }
    try {
        const issuesFormulas = getGeneratedStringForFormulaOnAllKeys({
            issueBoard: args.issueBoard,
            countersForIssuesOnAllKeys: args.sumsByFormula,
            issues: args.issues,
        });
        return args.issues.map((issue) => {
            const issueId = issue.id;
            if (issueId == null) {
                return { ...issue };
            }
            if (issuesFormulas[issueId] != null) {
                return {
                    ...issue,
                    otherAttributesData: {
                        ...issue.otherAttributesData,
                        ...issuesFormulas[issueId],
                    },
                };
            }
            return { ...issue };
        });
    }
    catch (error) {
        console.error("Error in getIssuesWithFormulaAdded:", error);
        return args.issues;
    }
};
